import React, { useState } from "react";
import {
  Menu,
  MenuItem,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import "./HamburgerMenu.css";

const HamburgerMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [modalType, setModalType] = useState<
    "Instructions" | "Notes" | "SkipExpedition" | null
  >(null);
  const [expeditionStatus, setExpeditionStatus] = useState<
    "RequestedSkip" | "NotRequired" | "NotStarted"
  >("NotStarted");
  const [note, setNote] = useState("");

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSkipRequest = () => {
    setExpeditionStatus("RequestedSkip");
    setModalType("SkipExpedition");
    handleMenuClose();
  };

  const handleReviewSkip = () => {
    setModalType("SkipExpedition");
    handleMenuClose();
  };

  const confirmSkip = () => {
    setExpeditionStatus("NotRequired");
    setNote("");
    setModalType(null);
  };

  const denySkip = () => {
    setExpeditionStatus("NotStarted");
    setNote("");
    setModalType(null);
  };

  const renderModalContent = () => {
    switch (modalType) {
      case "Instructions":
        return <div>Displaying Instructions content...</div>;
      case "Notes":
        return (
          <div>
            <p>Team leader and developer notes:</p>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Update developer notes here..."
            />
          </div>
        );
      case "SkipExpedition":
        return (
          <div>
            {expeditionStatus === "RequestedSkip" ? (
              <>
                <p>Review Skip Request:</p>
                <p>Note: {note}</p>
                <Button onClick={confirmSkip}>Confirm</Button>
                <Button onClick={denySkip}>Deny</Button>
              </>
            ) : (
              <>
                <p>Write a note for the skip request:</p>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Add note..."
                />
                <Button onClick={confirmSkip}>Confirm</Button>
                <Button onClick={() => setNote("")}>Reset</Button>
              </>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <Button onClick={handleMenuOpen}>☰</Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        className="hamb-menu-list"
      >
        <MenuItem
          onClick={() => {
            setModalType("Instructions");
            handleMenuClose();
          }}
        >
          Instructions
        </MenuItem>
        <MenuItem
          onClick={() => {
            setModalType("Notes");
            handleMenuClose();
          }}
        >
          Notes
        </MenuItem>
        {expeditionStatus === "RequestedSkip" ? (
          <MenuItem onClick={handleReviewSkip}>Review Skip</MenuItem>
        ) : (
          <MenuItem onClick={handleSkipRequest}>Skip Expedition</MenuItem>
        )}
      </Menu>

      <Dialog open={!!modalType} onClose={() => setModalType(null)}>
        <DialogContent>{renderModalContent()}</DialogContent>
        <DialogActions>
          <Button onClick={() => setModalType(null)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HamburgerMenu;
